import { gql } from 'graphql-request';
import {
  InvoiceClientId,
  InvoiceID,
  InvoiceName,
  InvoiceNanoID,
  InvoiceUUID
} from '../invoicesTypes';

export interface FetchCacheInvoicesSelectQueryResponse {
  id: InvoiceID;
  nanoId: InvoiceNanoID;
  uuid: InvoiceUUID;
  clientId: InvoiceClientId;
  name: InvoiceName;
}

export const FETCH_CACHE_INVOICES_SELECT_QUERY = gql`
  query CacheInvoicesSelect(
    $filters: InvoicesFilters
    $sort: [InvoicesSortEnum!]
    $offset: Int
    $limit: Int
    $source: String
  ) {
    invoices(
      filters: $filters
      sort: $sort
      limit: $limit
      offset: $offset
      source: $source
    ) {
      nodes {
        id
        nanoId
        uuid
        clientId
        name
      }
      paginationInfo {
        currentPage
        firstPage
        lastPage
        limitValue
        nextPage
        outOfRange
        prevPage
        totalCount
        totalPages
      }
      sql
    }
  }
`;
